import React, {ReactElement} from 'react';

import { RectanglePercentInterface, LayoutState} from "../../../store/layouts/types";
import CameraListContainer from "../../../containers/CameraListContainer";
import TitleCameraComponent from "../../reusable/TitleCameraComponent";
import './style.css';
import {useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {CamerasState} from "../../../store/cameras/types";

//@ts-ignore
// const { CONFIG } = window;

interface Props {
    positions: RectanglePercentInterface[],
    checkedPane: null | number,
    expandedVideoLayout: number | null,
    handler: (e:React.MouseEvent, i: number) => void,
    children: ReactElement,
    thumbnailPanes: number[]
}

const styleExpanded = {
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    zIndex: 2
};

const BrowseLayoutComponent: React.FC<Props> = (
        { positions, checkedPane, expandedVideoLayout, handler, children, thumbnailPanes }
    ) => {

    const {currentCameras} = useSelector<ApplicationState, CamerasState>(state => state.cameras);

    const browseElems = positions.map((styleDefault: RectanglePercentInterface, i: number) => {
            const classValue = i === checkedPane ? 'layout-item checked' : 'layout-item';
            const style = expandedVideoLayout === i ? styleExpanded : styleDefault;
            const cameraName = currentCameras[i] ? currentCameras[i].name : null;

            return (
                    <div className={classValue} style={style}
                         key={i}
                    >
                        <div className='pos-rel w-100 h-100'>
                            <div className='pos-rel w-100 h-100'
                                 onClick={(e) => handler(e, i)}
                                 onMouseDown={(e) => {e.preventDefault(); return false}}>
                                    <TitleCameraComponent pane={i}
                                                        cameraName={cameraName}
                                    />
                                    { React.cloneElement(children, { pane: i, isThumbnail: false })}
                            </div>
                            { checkedPane === i ? <CameraListContainer pane={i}/> : null  }
                        </div>
                    </div>
            )
        });

    const len = thumbnailPanes.length;
    const paneHeight = len ? window.CONFIG.thumbnails.height : 0;
    let rows = len > 5 ? 2 : 1;
    const styleBelow = {
        minHeight: expandedVideoLayout === null ? paneHeight + 'vh' : 0,
        maxHeight: expandedVideoLayout !== null ? 0 : paneHeight + 'vh'
    };

    const thumbnailElems = thumbnailPanes.map((pane, i) => {
        const amount = Math.round(len / rows);
        const left = (i % amount) / amount * 100;
        const height = paneHeight / rows;
        const width = 100 / amount;
        const top = Math.floor(i / amount) * height;

        const style = {
            left: left + '%',
            top: top + 'vh',
            width: width + '%',
            height: height + 'vh'
        };

        return (
            <div style={style}
                 className={'pos-abs'}
                 key={i + 2}
            >
                { React.cloneElement(children, { pane: i + 2, isThumbnail: true }) }
            </div>
        )
    });

    return (
        <div className='layout-container'>
            <div className={'layout-above-wrapper pos-rel w-100 h-100 '} > { browseElems } </div>
            <div className={'layout-below-wrapper'} style={styleBelow}>
                { thumbnailElems }
            </div>
        </div>
    )
};

export default BrowseLayoutComponent